import React from 'react';
import PropTypes from 'prop-types';
import '../styles/card2.css';

const Card2 = (props) => {
  return (
    <div className={`card2-feature-card ${props.rootClassName}`}>
      <div viewBox="0 0 1024 1024" className="card2-icon">
          {props.icon}
    </div>
      <h2 className="card2-text">{props.title}</h2>
      <span className="card2-text1">{props.description}</span>
    </div>
  );
};

Card2.defaultProps = {
  rootClassName: '',
  title: 'Lorem ipsum',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing.',
  icon: null,
};

Card2.propTypes = {
  action: PropTypes.string,
  rootClassName: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.elementType, // Updated PropTypes for the icon prop
};

export default Card2;

